import React, { useState, useEffect, useRef, useCallback } from "react";
import { withRouter, useParams } from "react-router-dom";

import { Table } from "@ui5/webcomponents-react/lib/Table";
import { TableColumn } from "@ui5/webcomponents-react/lib/TableColumn";
import { TableRow } from "@ui5/webcomponents-react/lib/TableRow";
import { TableCell } from "@ui5/webcomponents-react/lib/TableCell";
import { Text } from "@ui5/webcomponents-react/lib/Text";
import { PageBackgroundDesign } from "@ui5/webcomponents-react/lib/PageBackgroundDesign";
import { Page } from "@ui5/webcomponents-react/lib/Page";
import { Icon } from "@ui5/webcomponents-react/lib/Icon";
import "@ui5/webcomponents-icons/dist/icons/accept.js";
import "@ui5/webcomponents-icons/dist/icons/alert.js";
import MessageStripCompnt from "../../shared/components/UIElements/MessageStrip";
import { Title } from "@ui5/webcomponents-react/lib/Title";
import { TitleLevel } from "@ui5/webcomponents-react/lib/TitleLevel";
import { Button } from "@ui5/webcomponents-react/lib/Button";
import { ButtonDesign } from "@ui5/webcomponents-react/lib/ButtonDesign";
import { Dialog } from "@ui5/webcomponents-react/lib/Dialog";
import { ComboBox } from "@ui5/webcomponents-react/lib/ComboBox";
import { ComboBoxItem } from "@ui5/webcomponents-react/lib/ComboBoxItem";
import { TextArea } from "@ui5/webcomponents-react/lib/TextArea";
import { ValueState } from "@ui5/webcomponents-react/lib/ValueState";
import axios from "axios";

import "./SuppliersList.css";

const SuppliersList = (props) => {
  const approvalId = useParams().approvalId;

  const [error, setError] = useState("");
  const title = "Suppliers List";
  const [suppliersList, setSuppliersList] = useState([]);
  const [wizardName, setWizardName] = useState("");
  const [isPayrunApproved, setIsPayrunApproved] = useState(null);
  const [disableButtons, setDisableButtons] = useState(false);
  const [rejectionReasonCode, setRejectionReasonCode] = useState("");
  const [rejectionReasonComments, setRejectionReasonComments] = useState("");
  const [rejectReasons, setRejectReasons] = useState([]);

  const [reRenderTrigger, setReRenderTrigger] = useState(false);

  const isSupplierDocsCompleted = (waitingForApproval, approved) => {
    if (waitingForApproval - approved === 0) {
      return <Icon name={"accept"} className="icon__complete" />;
    } else {
      return <Icon name={"alert"} className="icon__incomplete" />;
    }
  };

  const getRejectReasons = async () => {
    setError(null);
    await axios
      .get(`/api/payruns/reject/codes`, {
        headers: { Authorization: props.token },
      })
      .then(function (response) {
        setRejectReasons(response.data);
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            setError(error.response.data.message);
            props.handleLogout();
          } else {
            setError(error.response.data.message);
          }
        } else {
          setError(
            "Something went wrong. Please verify your Internet connection."
          );
        }
      });
  };

  const getPayrunSuppliersList = async () => {
    setError(null);
    await axios
      .get(`/api/payruns/suppliers/` + approvalId + `/` + props.user, {
        headers: { Authorization: props.token },
      })
      .then(function (response) {
        setSuppliersList(response.data.rows);
        setIsPayrunApproved(response.data.rows[0].isApproved);
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            setError(error.response.data.message);
            props.handleLogout();
          } else {
            setError(error.response.data.message);
          }
        } else {
          setError(
            "Something went wrong. Please verify your Internet connection."
          );
        }
      });
  };

  const getWizardName = async () => {
    setError(null);
    await axios
      .get(`/api/payruns/wizardName/` + approvalId, {
        headers: { Authorization: props.token },
      })
      .then(function (response) {
        setWizardName(response.data.WizardName);
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            setError(error.response.data.message);
            props.handleLogout();
          } else {
            setError(error.response.data.message);
          }
        } else {
          setError(
            "Something went wrong. Please verify your Internet connection."
          );
        }
      });
  };

  const navBackButtonHandler = () => {
    props.history.goBack();
  };

  const onRowClickHandler = (e) => {
    props.history.push(
      `/approvals/${approvalId}/suppliers/${e.detail.row.id}/docs`
    );
  };

  const dialogRef = useRef();
  const openDialogHandler = useCallback(
    (e) => {
      dialogRef.current.open();
    },
    [dialogRef]
  );

  const closeDialogHandler = useCallback(() => {
    dialogRef.current.close();
    setRejectionReasonCode("");
    setRejectionReasonComments("");
  }, [dialogRef]);

  const onRejectReasonCodeChangeHandler = (e) => {
    setRejectionReasonCode(e.parameters.value);
  };
  const onRejectReasonCommentsInputHandler = (e) => {
    setRejectionReasonComments(e.parameters.value);
  };

  const onApproveAllHandler = async () => {
    setDisableButtons(true);
    setError(null);
    await axios
      .delete(`/api/payruns/docs/` + approvalId + `/user/` + props.user, {
        headers: {
          "Content-Type": "application/json",
          Authorization: props.token,
        },
      })
      .then(async function (response) {
        await axios
          .post(
            `/api/payruns/docs/` + approvalId + `/approved`,
            {
              approvalUserCode: props.user,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: props.token,
              },
            }
          )
          .then(function (response) {
            changeTriggerValue();
            setDisableButtons(false);
          })
          .catch(function (error) {
            setDisableButtons(false);
            if (error.response.status === 401) {
              setError(error.response.data.message);
              props.handleLogout();
            } else {
              setError(error.response.data.message);
            }
          });
      })
      .catch(function (error) {
        setDisableButtons(false);
        if (error.response.status === 401) {
          setError(error.response.data.message);
          props.handleLogout();
        } else {
          setError(error.response.data.message);
        }
      });
  };

  const onRejectAllHandler = async () => {
    setDisableButtons(true);
    setError(null);
    await axios
      .delete(`/api/payruns/docs/` + approvalId + `/user/` + props.user, {
        headers: {
          "Content-Type": "application/json",
          Authorization: props.token,
        },
      })
      .then(async function (response) {
        await axios
          .post(
            `/api/payruns/docs/` + approvalId + `/rejected`,
            {
              approvalUserCode: props.user,
              rejectReasonName: rejectionReasonCode,
              reasonRejectComments: rejectionReasonComments,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: props.token,
              },
            }
          )
          .then(function (response) {
            changeTriggerValue();
            closeDialogHandler();
            setDisableButtons(false);
          })
          .catch(function (error) {
            setDisableButtons(false);
            if (error.response.status === 401) {
              setError(error.response.data.message);
              props.handleLogout();
            } else {
              closeDialogHandler();
              setError(error.response.data.message);
            }
          });
      })
      .catch(function (error) {
        setDisableButtons(false);
        if (error.response.status === 401) {
          setError(error.response.data.message);
          props.handleLogout();
        } else {
          closeDialogHandler();
          setError(error.response.data.message);
        }
      });
  };

  const changeTriggerValue = () => {
    if (reRenderTrigger === false) {
      setReRenderTrigger(true);
    } else {
      setReRenderTrigger(false);
    }
  };

  useEffect(() => {
    getPayrunSuppliersList();
    getWizardName();
    getRejectReasons();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reRenderTrigger]);

  return (
    <Page
      title={title}
      showFooter={false}
      showHeader={true}
      showBackButton={true}
      backgroundDesign={PageBackgroundDesign.Transparent}
      onNavButtonPress={navBackButtonHandler}
    >
      <Title className="title" level={TitleLevel.H3} wrap={false}>
        {props.company.split("(")[0]}
        <br />
      </Title>
      <Title className="title" level={TitleLevel.H4} wrap={false}>
        {wizardName}
        <br />
      </Title>
      <Table
        noDataText={"No Suppliers Found"}
        showNoData={false}
        stickyColumnHeader={false}
        columns={[
          <TableColumn>
            <Text>Supplier</Text>
          </TableColumn>,
          <TableColumn>
            <Text>Total</Text>
          </TableColumn>,
        ]}
        onRowClick={onRowClickHandler}
      >
        {suppliersList.map((supplier) => (
          <TableRow key={supplier.CardCode} id={supplier.CardCode}>
            <TableCell>
              <Text>{supplier.CardName}</Text>
            </TableCell>
            <TableCell className="text_aligned">
              {isSupplierDocsCompleted(
                supplier.WaitingApproval,
                supplier.Approved
              )}
              <Text>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: supplier.LocCurr,
                  minimumFractionDigits: 2,
                }).format(parseFloat(supplier.Total))}
              </Text>
            </TableCell>
          </TableRow>
        ))}
      </Table>
      {error && <MessageStripCompnt type="error" message={error} />}
      {!isPayrunApproved && (
        <div>
          <Button
            id="reject_all"
            design={ButtonDesign.Negative}
            icon="decline"
            onClick={openDialogHandler}
            className="button__rejectall"
            disabled={disableButtons}
          >
            (All)
          </Button>
          <Button
            design={ButtonDesign.Positive}
            icon="accept"
            onClick={onApproveAllHandler}
            className="button__acceptall"
            disabled={disableButtons}
          >
            (All)
          </Button>
        </div>
      )}
      <Dialog
        ref={dialogRef}
        stretch={false}
        initialFocus={""}
        footer={null}
        header={null}
        className="container"
      >
        <p>Please state the motive for the rejection:</p>
        <ComboBox
          disabled={false}
          filter={"StartsWithPerTerm"}
          filterValue={""}
          loading={false}
          placeholder={""}
          readonly={false}
          required={true}
          value={rejectionReasonCode}
          valueState={ValueState.None}
          onChange={onRejectReasonCodeChangeHandler}
        >
          {rejectReasons.map((reason) => (
            <ComboBoxItem key={reason.Code} text={reason.Name} />
          ))}
        </ComboBox>
        <p>Reject reason comments:</p>
        <TextArea
          disabled={false}
          growing={false}
          growingMaxLines={0}
          maxlength={null}
          name={undefined}
          placeholder={""}
          readonly={false}
          required={false}
          rows={0}
          showExceededText={false}
          value={rejectionReasonComments}
          valueState={ValueState.None}
          valueStateMessage={<span>Value State Message</span>}
          onInput={onRejectReasonCommentsInputHandler}
        />
        <div className="buttons_container">
          {error && <MessageStripCompnt type="error" message={error} />}
          <Button
            className="btn__submitall"
            design={ButtonDesign.Negative}
            onClick={closeDialogHandler}
          >
            Cancel
          </Button>
          <Button
            className="btn__submitall"
            design={ButtonDesign.Positive}
            onClick={onRejectAllHandler}
            disabled={disableButtons}
          >
            Submit
          </Button>
        </div>
      </Dialog>
    </Page>
  );
};

export default withRouter(SuppliersList);
